/* eslint-disable no-constant-condition */
import * as types from "../constants/actionTypes";
import { getConfig } from "../api/config";
import { generateAsyncAction } from "./generateAsyncAction";

export const getServerConfig = lang => async (dispatch, getState) => {
  const configAction = await generateAsyncAction({
    onSuccessAction: configSuccess,
    onFailAction: configFail,
    asyncApiMethod: getConfig,
    request: lang
  });
  const { isMobileView, showCartSubmitBtn } = getState();
  let action = configAction;
  if (isMobileView || !showCartSubmitBtn) {
    // force "enableSinglePaxCartSkipping" on mobile or when showCartSubmitBtn is ture as we don't have a continue button
    action = {
      ...configAction,
      payload: {
        ...configAction.payload,
        enableSinglePaxCartSkipping: true
      }
    };
  }
  return dispatch(action);
};

export const configSuccess = ({ payload }) => {
  return {
    type: types.CONFIG_SUCCESS,
    payload
  };
};

export const configFail = ({ message, title }) => ({
  type: types.CONFIG_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/configActions.js